export default __webpack_public_path__ + "static/logo-blue-6ad3184cf32b9d3a8ba0cebdd22f4003.svg";